import { DepartmentGroupResource } from '@/entities/DepartmentGroup/DepartmentGroup'
import { transformToDepartmentGroup } from '@/entities/DepartmentGroup/departmentGroupTransformers'

import { Department, DepartmentResource } from './Department'

export const transformToDepartment = (department: DepartmentResource, departmentGroup?: DepartmentGroupResource): Department => ({
    id: department.id,
    name: department.attributes.name,
    departmentGroup: departmentGroup ? transformToDepartmentGroup(departmentGroup) : undefined,
})
